<nav class="navbar navbar-light bg-gray">
  <a class="navbar-brand" href="{{marketingLink}}">
    <img src="/assets/images/influencer-impact-logo.svg" width="102" height="25" alt="">
  </a>
  <button class="button blue" (click)="openIntercom()">{{'contact_permission.chat' | translate}}</button>
</nav>
<div class="container-fluid">
  <div class="row">
    <div class="col-12" *ngIf="isAccepted">
      <div class="main-content">
        <div class="cover-image">
          <img src="assets/images/connection-bg.png">
        </div>
        <div class="messages">
          <h2 class="main-title">{{'contact_permission.title' | translate:{advertiserName: advertiserName, company: companyName} }}</h2>
          <p class="message-line">{{'contact_permission.message_1' | translate:{influencerName: influencerName} }}</p>
          <p class="inter-message message-line">{{'contact_permission.message_2' | translate:{advertiserName: advertiserName, company: companyName} }}</p>
          <p class="message-line">{{'contact_permission.message_3' | translate:{advertiserName: advertiserName} }}</p>
        </div>
        <div class="button-group">
          <a href="{{marketingLink}}" class="button btn-learn-about blue">{{'contact_permission.learn_about' | translate}}</a>
          <a class="reject-link" (click)="rejectPermission()">{{'contact_permission.reject_link' | translate}}</a>
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="isRejected">
      <div class="main-content">
        <div class="cover-image">
          <img src="assets/images/connection-bg.png">
        </div>
        <div class="messages">
          <h2 class="main-title">{{'contact_permission.reject_title' | translate}}</h2>
          <p class="message-line">{{'contact_permission.reject_message' | translate}}</p>
        </div>
        <div class="button-group">
          <a class="button btn-undo-reject blue" (click)="acceptPermission()">
            {{'contact_permission.undo_rejection_btn' | translate:{advertiserName: advertiserName} }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-connection/influencer-connection.component.html